export const FeedbackReviewResourceBS: FeedbackReviewInterface = {
  title: "Pregled feedbacka",
  description: "Pregledajte sve feedback poruke za odabranu poslovnicu",
  selectConfig: {
    label: "Odaberite evidenciju",
    placeholder: "Odaberite evidenciju",
    notFound: "Nema dostupnih evidencija",
  },
  selectBranch: {
    label: "Odaberite poslovnicu",
    placeholder: "Odaberite poslovnicu",
    notFound: "Nema dostupnih poslovnica",
  },
  noFeedbacks: "Nema feedback poruka za odabranu poslovnicu",
  loadMore: "Učitaj više",
  loadingMore: "Učitavanje...",
  feedbackCard: {
    date: "Datum",
    time: "Vrijeme",
    recordPoint: "Tačka primjene",
    anonymous: "Anonimno",
    dataEntry: "Unos podataka",
    email: "Email",
    phone: "Telefon",
    comment: "Komentar / pohvala",
    images: "Slike",
    noComment: "Nema komentara",
    noImages: "Nema slika",
  },
  errors: {
    errorLoading: "Došlo je do greške tokom učitavanja feedbacka. Molimo kontaktirajte administratora.",
    errorLoadingConfigs: "Došlo je do greške tokom učitavanja evidencija. Molimo kontaktirajte administratora.",
    noManagerAccess: "Nemate pristup ovoj stranici. Morate biti postavljeni kao menadžer u konfiguraciji evidencije.",
    unauthorized: "Nemate dozvolu za pristup ovim podacima.",
  },
};

export const FeedbackReviewResourceEN: FeedbackReviewInterface = {
  title: "Feedback Review",
  description: "Review all feedback messages for the selected branch",
  selectConfig: {
    label: "Select evidence",
    placeholder: "Select evidence",
    notFound: "No evidence available",
  },
  selectBranch: {
    label: "Select branch",
    placeholder: "Select branch",
    notFound: "No branches available",
  },
  noFeedbacks: "No feedback messages for the selected branch",
  loadMore: "Load More",
  loadingMore: "Loading...",
  feedbackCard: {
    date: "Date",
    time: "Time",
    recordPoint: "Application point",
    anonymous: "Anonymous",
    dataEntry: "Data Entry",
    email: "Email",
    phone: "Phone",
    comment: "Comment / Praise",
    images: "Images",
    noComment: "No comment",
    noImages: "No images",
  },
  errors: {
    errorLoading: "An error occurred while loading feedback. Please contact the administrator.",
    errorLoadingConfigs: "An error occurred while loading evidence. Please contact the administrator.",
    noManagerAccess: "You do not have access to this page. You must be set as a manager in the evidence configuration.",
    unauthorized: "You do not have permission to access this data.",
  },
};

export const FeedbackReviewResourceDE: FeedbackReviewInterface = {
  title: "Feedback-Übersicht",
  description: "Überprüfen Sie alle Feedback-Nachrichten für die ausgewählte Filiale",
  selectConfig: {
    label: "Evidenz auswählen",
    placeholder: "Evidenz auswählen",
    notFound: "Keine Evidenz verfügbar",
  },
  selectBranch: {
    label: "Filiale auswählen",
    placeholder: "Filiale auswählen",
    notFound: "Keine Filialen verfügbar",
  },
  noFeedbacks: "Keine Feedback-Nachrichten für die ausgewählte Filiale",
  loadMore: "Mehr laden",
  loadingMore: "Laden...",
  feedbackCard: {
    date: "Datum",
    time: "Zeit",
    recordPoint: "Anwendungspunkt",
    anonymous: "Anonym",
    dataEntry: "Dateneingabe",
    email: "E-Mail",
    phone: "Telefon",
    comment: "Kommentar / Lob",
    images: "Bilder",
    noComment: "Kein Kommentar",
    noImages: "Keine Bilder",
  },
  errors: {
    errorLoading: "Beim Laden des Feedbacks ist ein Fehler aufgetreten. Bitte kontaktieren Sie den Administrator.",
    errorLoadingConfigs: "Beim Laden der Evidenz ist ein Fehler aufgetreten. Bitte kontaktieren Sie den Administrator.",
    noManagerAccess: "Sie haben keinen Zugriff auf diese Seite. Sie müssen als Manager in der Evidenzkonfiguration festgelegt werden.",
    unauthorized: "Sie haben keine Berechtigung, auf diese Daten zuzugreifen.",
  },
};

export interface FeedbackReviewInterface {
  title: string;
  description: string;
  selectConfig: {
    label: string;
    placeholder: string;
    notFound: string;
  };
  selectBranch: {
    label: string;
    placeholder: string;
    notFound: string;
  };
  noFeedbacks: string;
  loadMore: string;
  loadingMore: string;
  feedbackCard: {
    date: string;
    time: string;
    recordPoint: string;
    anonymous: string;
    dataEntry: string;
    email: string;
    phone: string;
    comment: string;
    images: string;
    noComment: string;
    noImages: string;
  };
  errors: {
    errorLoading: string;
    errorLoadingConfigs: string;
    noManagerAccess: string;
    unauthorized: string;
  };
}

